
import { defineComponent, ref, watch } from "vue";
import { hideModal } from "@/core/helpers/dom";
import ApiService from "@/core/services/ApiService";
import { Mutations } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import DatePicker from "vue3-persian-datetime-picker";
import { getLocale } from "@/core/services/HelpersFun";
interface DataInterface {
  title: string;
  description: string;
  start_datetime: string;
  finish_datetime: string;
  status: string;
  color: string; // error | info | success | warning
}

export default defineComponent({
  name: "create-modal-notice",
  emits: ["refreshList"],
  components: { DatePicker },
  props: {
    id: {
      type: Number,
      default: undefined,
    },
    type: {
      type: String,
      default: "create", // create | edit
    },
  },
  setup(props, { emit }) {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) return t(text);
      return text;
    };

    const store = useStore();
    const submitButton = ref<HTMLButtonElement | null>(null);
    const errorsBag = ref({});
    const editMode = ref(false);
    const formRef = ref<null | HTMLFormElement>(null);
    const newTargetModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);

    const targetData = ref<DataInterface>({
      title: "",
      description: "",
      finish_datetime: "",
      start_datetime: "",
      status: "active", // active | deactive
      color: "info",
    });

    const rules = ref({
      title: [
        {
          required: true,
          message: "لطفا عنوان اطلاعیه را وارد کنید",
          trigger: "blur",
        },
      ],
      description: [
        {
          required: true,
          message: "توضیح اطلاعیه را وارد کنید",
          trigger: "blur",
        },
      ],
    });

    const submit = () => {
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      errorsBag.value = {};

      let url =
        props.type === "edit"
          ? `admin/notice/${props.id}/edit`
          : "admin/notice/create";

      ApiService.post(url, targetData.value)
        .then(() => {
          hideModal(newTargetModalRef.value);
          emit("refreshList");
          editMode.value = false;
          clear();
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        })
        .finally(() => {
          if (submitButton.value) {
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            // eslint-disable-next-line
              submitButton.value!.disabled = false;
          }
        });
    };

    const clear = () => {
      editMode.value = false;
      targetData.value = {
        title: "",
        description: "",
        finish_datetime: "",
        start_datetime: "",
        status: "active",
        color: "info",
      };
    };


    const finish = ref();
    const start = ref();
    const showNotice = (id) => {
      loading.value = true;
      ApiService.get(`admin/notice/${id}`)
        .then(({ data }) => {
          editMode.value = true;
          let holder = data.data.notice;
          targetData.value.title = holder.title;
          targetData.value.description = holder.description;
          targetData.value.finish_datetime = holder?.finish_datetime?.gregorian;
          targetData.value.start_datetime = holder?.start_datetime?.gregorian;
          targetData.value.status = holder.status;
          targetData.value.color = holder.color;

          finish.value =  holder?.finish_datetime?.jalali
          start.value =  holder?.start_datetime?.jalali
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    watch(
      () => props.id,
      (id) => {
        if (!id) return clear();

        showNotice(id);
      }
    );

    return {
      translate,
      submitButton,
      targetData,
      submit,
      loading,
      formRef,
      rules,
      newTargetModalRef,
      errorsBag,
      editMode,
      getLocale,
      finish,
      start,
    };
  },
});
